define.alias("shared/components/shared/social/refresh-profile/pinterest", "calendar/components/shared/social/refresh-profile/pinterest");